import React from 'react';
import { filterUserColumns } from '../../common/FilterUsersColumns';
import filterUsersTableStyle from '../../assets/jss/material-dashboard-react/views/filterUsersTableStyle';


const FilterUsersTable = ({ users }) => {
  const headers = filterUserColumns;

  return (
    <table style={filterUsersTableStyle.usersTable}>
      <thead>
        <tr>
          {headers.map((header, index) => (
            <th style={filterUsersTableStyle.th} key={index}>{header.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {users.map((user, index) => (
          <tr style={filterUsersTableStyle.tr} key={index}>
            {headers.map((header, index) => (
              <td style={filterUsersTableStyle.td} key={index}>{user[header.name]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default FilterUsersTable;
